import { useEffect, useState } from "react";

/**
 * Will return a truthy value when hydration has occurred
 */
const useHydration = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(true);
  }, []);

  return enabled;
};

export default useHydration;
